export default {
  path: 'protocols',
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: [
    {
      path: '',
      name: 'protocols',
      component: () =>
        import(
          /* webpackChunkName: "allStudies" */ '../views/Protocol/List/ProtocolListContainerView.vue'
        ),
    },
    {
      path: 'protocol/:id',
      component: () =>
        import(
          /* webpackChunkName: "studyView" */ '../views/Protocol/View.vue'
        ),

      children: [
        {
          path: '',
          name: 'view-protocol',
          component: () =>
            import(
              /* webpackChunkName: "studyDetails" */ '../views/Protocol/Details.vue'
            ),
        },

        {
          path: 'edit',
          name: 'edit-protocol',
          meta: {
            parent: 'protocol',
          },
          component: () =>
            import(
              /* webpackChunkName: "ViewProtocol" */ '../views/Protocol/Edit.vue'
            ),
        },
        {
          path: 'sites',

          component: {
            render(c) {
              return c('router-view');
            },
          },

          children: [
            {
              path: '',
              name: 'protocol-sites',
              meta: {
                parent: 'protocol',
              },
              component: () =>
                import(
                  /* webpackChunkName: "protocols" */ '../views/Sites/List/QuickSiteListContainerView.vue'
                ),
            },
            {
              path: 'add',
              name: 'protocol-create-site',
              meta: {
                parent: 'protocol',
              },
              component: () =>
                import(
                  /* webpackChunkName: "createSite" */ '../views/Sites/Create.vue'
                ),
            },
            {
              path: 'site',

              component: {
                render(c) {
                  return c('router-view');
                },
              },

              children: [
                {
                  path: '',
                  name: 'protocol-view-site',
                  meta: {
                    parent: 'protocol',
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "viewSite" */ '../views/Sites/Details.vue'
                    ),
                },

                {
                  path: 'edit',
                  name: 'protocol-edit-site',
                  meta: {
                    parent: 'protocol',
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "updateSite" */ '../views/Sites/Edit.vue'
                    ),
                },

                {
                  path: 'members',
                  name: 'protocol-site-list-team',
                  component: () =>
                    import(
                      /* webpackChunkName: "TeamMembersList" */ '../views/TeamMember/List/TeamMemberListContainer.vue'
                    ),
                },
                {
                  path: 'participants',
                  meta: {
                    parent: 'protocol',
                  },
                  component: {
                    render(c) {
                      return c('router-view');
                    },
                  },

                  children: [
                    {
                      path: '',
                      name: 'protocol-site-participants',
                      meta: {
                        parent: 'protocol',
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "viewParticipant" */ '../views/Participants/List/QuickParticipantListContainerView.vue'
                        ),
                    },
                    {
                      path: 'participant',
                      name: 'protocol-view-participant',
                      meta: {
                        parent: 'protocol',
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "viewParticipant" */ '../views/Participants/View.vue'
                        ),
                    },

                    {
                      path: 'add',
                      name: 'protocol-create-participant',
                      meta: {
                        parent: 'protocol',
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "createParticipant" */ '../views/Participants/Create.vue'
                        ),
                    },

                    {
                      path: 'view-relapse',
                      name: 'protocol-view-relapse',
                      meta: {
                        parent: 'protocol',
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "viewRelapse" */ '../views/Relapses/RelapseDetailView.vue'
                        ),
                    },

                    {
                      path: 'create-relapse-schedule',
                      name: 'protocol-create-relapse-schedule',
                      meta: {
                        parent: 'protocol',
                      },
                      component: () =>
                        import(
                          /* webpackChunkName: "create-relapse-schedule" */ '../views/Relapses/CreateRelapseView.vue'
                        ),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: 'participants',
          name: 'protocol-participants',
          meta: {
            parent: 'protocol',
          },
          component: () =>
            import(
              /* webpackChunkName: "protocols" */ '../views/Participants/List/QuickParticipantListContainerView.vue'
            ),
        },
      ],
    },
  ],
};
